import React from 'react';

import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';

import type { TransactionEditViewModel } from '../TransactionEditViewModel';
import WorkflowDialogComponents from './WorkflowDialogComponents';
import WorkflowDrawerComponents from './WorkflowDrawerComponents';

type Props = {
  rootModalDrawer?: RootModalDrawerOptions;
  viewModel: TransactionEditViewModel;
};

export default function WorkflowCoordinator({ rootModalDrawer, viewModel }: Props): React.JSX.Element {
  return (
    <>
      {rootModalDrawer ? <WorkflowDrawerComponents rootModalDrawer={rootModalDrawer} viewModel={viewModel} /> : null}
      {!rootModalDrawer ? <WorkflowDialogComponents viewModel={viewModel} /> : null}
    </>
  );
}
